export default __webpack_public_path__ + "static/media/trello-icon.e63c94b1.svg";